
export const apiGet = async (url) => {
  try {
    const token = sessionStorage.getItem("access_token");
    const res = await fetch(url, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });

    if (!res.ok) {
      throw new Error(`Error HTTP ${res.status}: ${res.statusText}`);
    }

    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error en API GET:", error);
    throw error;
  }
};
